<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.vehicle_type, 'Tip vehicul')"
      :items="vehicleTypes"
      item-title="name"
      name="vehicle_type"
      item-value="code"
      :loading="loading"
      :disabled="loading"
      v-model="selectedVehicleType"
      :rules="[v => !!v || translation(translationList.required, 'Acest camp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useVehicleStore } from '~/plugins/store/vehicle';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {VehicleType} from "~/types/Vehicle";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => VehicleType | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const vehicleStore = useVehicleStore();
    const translationStore = useTranslationStore();
    const selectedVehicleType = ref(modelValue.value ? modelValue.value : null);
    const vehicleTypes = ref<VehicleType[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref([]);

    onMounted(async () => {
      loading.value = true;
      vehicleTypes.value = await vehicleStore.getVehicleTypes();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      if (!modelValue.value && vehicleTypes.value.length > 0) {
        selectedVehicleType.value = vehicleTypes.value[0];
        emit('update:modelValue', selectedVehicleType.value);
      }
      loading.value = false;
      const isValid = !!selectedVehicleType.value;
      emit('validation-vehicle-status', { field: 'vehicle_type', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'vehicle_type') {
          if (!selectedVehicleType.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-vehicle-status', { field: 'vehicle_type', isValid: true });
          }
        }
      });
    });

    watch(selectedVehicleType, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (newValue && (newValue.code !== selectedVehicleType.value?.code)) {
        selectedVehicleType.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'vehicle_type', isValid });
    });

    return {
      selectedVehicleType,
      translationList,
      translation,
      vehicleTypes,
      loading,
      error,
    };
  },
});
</script>

<style scoped>
</style>
